export class Livestock {
    id: number;
    name: string;

    brand: string;
    earTag: string;


    constructor(brand = null, name = null) {
        this.brand = brand;
        this.name = name;
    }
}


// WEBPACK FOOTER //
// ./src/model/livestock.ts